import Help1 from '../Help/Help1.jpg'
import Help2 from '../Help/Help2.png'
import Help3 from '../Help/Help3.png'
import Help4 from '../Help/Help4.png'
import Help5 from '../Help/Help5.png'

export const HelpData = [{
        url: Help1,
    },
    {
        url: Help2,
    },
    {
        url: Help3,
    },
    {
        url: Help4,
    },
    {
        url: Help5,
    },
]